export default __webpack_public_path__ + "static/media/tail.449d6a3b.svg";